import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="mt-16 bg-primary-950 text-background-50">
      <div className="mx-auto grid w-full grid-cols-1 gap-8 px-4 py-10 md:grid-cols-2 md:px-6 md:py-14 lg:grid-cols-4">
        <div className="lg:col-span-2">
          <div className="flex items-center gap-2">
            <span className="flex h-10 w-10 items-center justify-center rounded-md bg-accent-500 text-background-50">
              <i className="ri-movie-2-line text-xl" />
            </span>
            <span className="font-heading text-xl font-extrabold tracking-tight">一路向西</span>
          </div>
          <p className="mt-4 max-w-md text-sm leading-relaxed text-primary-200">
            一路向西影视内容平台，专注影视作品的剧情梳理、角色分析与最新影视动态，为影视爱好者、剧情粉丝与研究者提供丰富、易读、成体系的影视资讯阅读服务。
          </p>
          <div className="mt-4 flex items-center gap-3 text-primary-200">
            <a href="mailto:hello@yiluxiangxi.example" className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-900 transition-colors hover:bg-accent-500 hover:text-background-50" aria-label="邮箱">
              <i className="ri-mail-line text-base" />
            </a>
            <a href="mailto:hello@yiluxiangxi.example" className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-900 transition-colors hover:bg-accent-500 hover:text-background-50" aria-label="微博">
              <i className="ri-weibo-line text-base" />
            </a>
            <a href="mailto:hello@yiluxiangxi.example" className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-900 transition-colors hover:bg-accent-500 hover:text-background-50" aria-label="公众号">
              <i className="ri-wechat-line text-base" />
            </a>
          </div>
        </div>

        <div>
          <h2 className="font-heading text-sm font-semibold tracking-wide text-background-50">影视分类</h2>
          <ul className="mt-4 space-y-2 text-sm text-primary-200">
            <li><Link to="/category/movie" className="transition-colors hover:text-accent-300">电影栏目</Link></li>
            <li><Link to="/category/tv" className="transition-colors hover:text-accent-300">电视剧栏目</Link></li>
            <li><Link to="/category/web" className="transition-colors hover:text-accent-300">网络剧栏目</Link></li>
            <li><Link to="/category/all" className="transition-colors hover:text-accent-300">全部影视</Link></li>
          </ul>
        </div>

        <div>
          <h2 className="font-heading text-sm font-semibold tracking-wide text-background-50">关于与帮助</h2>
          <ul className="mt-4 space-y-2 text-sm text-primary-200">
            <li><Link to="/about" className="transition-colors hover:text-accent-300">站点介绍</Link></li>
            <li><Link to="/about" className="transition-colors hover:text-accent-300">联系方式</Link></li>
            <li><Link to="/#specials" className="transition-colors hover:text-accent-300">精选专题</Link></li>
            <li><Link to="/about" className="transition-colors hover:text-accent-300">数据来源说明</Link></li>
          </ul>
        </div>
      </div>

      <div className="border-t border-primary-900">
        <div className="mx-auto flex w-full flex-col items-center justify-between gap-3 px-4 py-5 text-xs text-primary-300 md:flex-row md:px-6">
          <p>© {new Date().getFullYear()} 一路向西影视内容平台 · 演示站点，内容均为虚构示例</p>
          <p className="flex flex-wrap items-center justify-center gap-x-4 gap-y-1">
            <span>内容仅供学习与阅读参考</span>
            <span className="hidden sm:inline">·</span>
            <span>本站不提供任何影视资源下载</span>
          </p>
        </div>
      </div>
    </footer>
  );
}